

















import Vue from 'vue';
import Amplify from 'aws-amplify'
// import * as AmplifyUI from '@aws-amplify/ui';
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';

export default Vue.extend({

  name: 'AuthSignOutButton',

  props: {
    signOutConfig: {
      type: Object,
    },
  },

  data () {
    return {
      error:  null as any,
      logger: {} as any,
    }
  },

  created() {
    this.logger = new Amplify.Logger(this.$options.name);          
  },

  computed: {
    options(): any {
      const defaults = {
        msg: null,
        signOutButton: Amplify.I18n.get('Logout')
      }
      return Object.assign(defaults, this.signOutConfig || {})
    }
  },

  methods: {
      
    signOut(event: any) {
      let vm: any = this;
        Amplify.Auth.signOut()
        .then( () => {
          vm.logger.info('signout success')
          return AmplifyEventBus.$emit('authState', 'signedOut')
        })
        .catch( (e: any) => vm.setError(e));
    },
    
    setError(e: any) {
      this.error = Amplify.I18n.get(e.message || e);
      this.logger.error(this.error)
    },

  },

});
